
export const errorFocusMixins = {
	methods: {
		scrollToField(fieldElement) {
			if (fieldElement && fieldElement.$el) {
				const topOffset = fieldElement.$el.offsetTop;
				window.scrollTo({ top: topOffset, behavior: 'smooth' });
				fieldElement.$el.focus();
			  }
		  },
		setFocusOnFirstErrorField() {
			this.$nextTick(() => {
				const firstErrorElement = document.querySelector('.error-check');
				if (firstErrorElement) {
				  firstErrorElement.scrollIntoView({ behavior: 'smooth' });
				  firstErrorElement.focus();
				}
			  });
		  },
	}
}